import { zodResolver } from '@hookform/resolvers/zod';
import { IconButton, Paper, Stack } from '@mui/material';
import type { PlanOverview } from '@vy/api-definition';
import { VyIcon } from '@vy/ui-design-system';
import type { Plan } from '@vy/types';
import { isNotEmptyString, isNotNullOrUndefined } from '@vy/utils';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { ContractInfoHeader } from '../../../contract/contract-page-components/ContractPageHeader/contract-page-header-components/ContractInfoHeader';
import { ContractPageTitle } from '../../../contract/contract-page-components/ContractPageHeader/contract-page-header-components/ContractPageTitle';
import { CreateContractSidebar } from '../../PlansPage/plans-page-components/CreateContractSidebar';
import { PlanMenuModal } from '../../PlansPage/plans-page-components/PlanDotMenu/PlanDotMenuModal';
import type { NewPlanAssignment } from '../../PlansPage/plans-page-types/new-plan-assignment-schema';
import { NewPlanAssignmentSchema } from '../../PlansPage/plans-page-types/new-plan-assignment-schema';
import type { PlanAssignmentInput } from '../../PlansPage/plans-page-types/plan-assignment-input-schema';

type PlanHeaderProps = {
  plan: Plan;
  planOverview: PlanOverview;
};

export const PlanPageHeader: React.FC<PlanHeaderProps> = ({ plan, planOverview }) => {
  const methods = useForm<PlanAssignmentInput, NewPlanAssignment>({
    resolver: zodResolver(NewPlanAssignmentSchema),
  });

  const contract = methods.watch('contract');

  return (
    <FormProvider {...methods}>
      <Paper
        sx={{
          width: '100%',
          gap: '16px',
          borderRadius: '8px',
          border: '1px',
          padding: '24px',
          minWidth: '380px',
        }}
        elevation={1}
      >
        <Stack
          direction="row"
          sx={{
            justifyContent: "space-between",
            alignItems: "flex-start"
          }}>
          <Stack direction="column">
            <Stack direction="row" spacing={2} sx={{
              alignItems: "center"
            }}>
              <ContractPageTitle plan={plan} />
            </Stack>

            <ContractInfoHeader plan={plan} status={plan.status} />
          </Stack>

          <PlanMenuModal plan={planOverview} refetchFunction={() => {}}>
            <IconButton>
              <VyIcon icon="DotsMenu" style={{ rotate: '90deg' }} />
            </IconButton>
          </PlanMenuModal>
        </Stack>
      </Paper>
      {isNotNullOrUndefined(contract) && isNotEmptyString(contract.planId) && (
        <CreateContractSidebar title="Assign customer" planId={contract.planId} />
      )}
    </FormProvider>
  );
};
